import { render, staticRenderFns } from "./ProjectCards.vue?vue&type=template&id=0506bff1&scoped=true&"
import script from "./ProjectCards.vue?vue&type=script&lang=js&"
export * from "./ProjectCards.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCards.vue?vue&type=style&index=0&id=0506bff1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0506bff1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VIcon,VSpacer})
